// Reverse-geocode a lat/lng into a human-readable Philippine-style address via
// our backend proxy (GET /api/geocode/reverse), which caches results server-side.
// Results are also cached client-side (in-memory + sessionStorage) to avoid
// repeat round-trips for the same pin.

const memCache = new Map();

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const reverseGeocode = async (lat, lng) => {
  if (lat == null || lng == null) return '';
  const key = `${(+lat).toFixed(5)},${(+lng).toFixed(5)}`;
  if (memCache.has(key)) return memCache.get(key);
  try {
    const cached = sessionStorage.getItem(`revgeo:${key}`);
    if (cached) { memCache.set(key, cached); return cached; }
  } catch (_) {}
  try {
    const res = await fetch(`${API}/geocode/reverse?lat=${lat}&lng=${lng}`);
    const data = await res.json();
    const addr = data && data.address ? data.address : '';
    if (addr) {
      memCache.set(key, addr);
      try { sessionStorage.setItem(`revgeo:${key}`, addr); } catch (_) {}
    }
    return addr;
  } catch (_) {
    return '';
  }
};
